import { connect } from 'react-redux';
import { fetchCurrentBot, fetchCurrentBotSuccess, fetchCurrentBotFailure } from '../../../actions/current-bot.js';
import Dashboard from  '../../templates/DashboardSubjects';

//Binding the data
const mapStateToProps = (state) => {
    return {
        currentBot: state.currentBot,
        selectedSubject: state.selectedSubject
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchCurrentBot: (botId) => {
            dispatch(fetchCurrentBot(botId)).then((response) => {
                !response.error ? dispatch(fetchCurrentBotSuccess(response.payload.data)) : dispatch(fetchCurrentBotFailure(response.payload.data));
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/redux/components/pages/DashboardSubjects/DashboardSubjectsContainer.js